import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import { useForm } from 'react-hook-form';
import Select from 'react-select'

// reactstrap components
import { Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Nav, NavItem, NavLink, TabPane, TabContent } from "reactstrap";


// services
import { showMessage } from "../../services/message.js";
import { api_GET, api_POST, api_PUT } from "../../services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "../../services/acesso.js";

//Context
import { useAuth } from '../../context/auth.js';

export default function CadastroClassesResiduosForm({ item, handleReturn }) {
  const {session, setLoading} = useAuth();

  const { register, handleSubmit, errors, setValue, clearErrors, getValues } = useForm({ mode: "onBlur" });

  const [permiteEditar, set_permiteEditar] = React.useState(false);

  const [classeResiduo_Id, set_classeResiduo_Id] = React.useState(0);

  // Status    
  const [status, set_status] = React.useState("");
  const [options_status] = React.useState([
    { value: "Ativo", label: "Ativo" },
    { value: "Inativo", label: "Inativo" },
  ]);
  const handleStatus = (value) => {
    set_status(value);
    setValue("status", value, true);
    clearErrors("status");
  }

  // Categoria
  const [categoria, set_categoria] = React.useState(null);
  const [options_categoria, set_options_categoria] = React.useState([]);
  const loadOptionsCategoria = (_segmento) => {
    api_GET(`Categoria`)
      .then(result => set_options_categoria(result.data))
      .catch(err => showMessage("Aviso", err.message, 'error', null))
  }
  const handleCategoria = (value) => {
    set_categoria(value);
    setValue("categoria", value, true);
    clearErrors("categoria");
  }

  // Status Resíduo
  const [statusResiduo, set_statusResiduo] = React.useState("");
  const [options_statusResiduo] = React.useState([
    { value: "Ativo", label: "Ativo" },
    { value: "Inativo", label: "Inativo" },
  ]);
  const handleStatusResiduo = (value) => {
    set_statusResiduo(value);
    setValue("statusResiduo", value, true);
    clearErrors("statusResiduo");
  }

  const [rowEdit, set_rowEdit] = React.useState(null);
  const [list_table_residuos, set_list_table_residuos] = React.useState([]);
  const handleEditarResiduo = (rowData) => {
    set_rowEdit(rowData);
    set_statusResiduo(rowData.status);
    setValue("statusResiduo", rowData.status, true);
    setValue("descricaoResiduo", rowData.descricao);
  }
  // Adicionar Resíduo
  const confirmacaoResiduoAdicionado = (item) => {
    let new_list = [];
    list_table_residuos.map(m => {
      if (m.residuo_Id == item.residuo_Id)
        new_list.push(item);
      else
        new_list.push(m);
    });
    if (list_table_residuos.filter(f => f.residuo_Id == item.residuo_Id).length == 0)
      new_list.push(item);

    set_list_table_residuos(new_list);

    set_rowEdit(null);
    set_statusResiduo("");
    setValue("statusResiduo", "", false);
    setValue("descricaoResiduo", "");
  }

  const handleAdicionarResiduo = () => {
    if (classeResiduo_Id == 0) {
      showMessage("Aviso", "Salve o cadastro da classe na primeira aba antes de incluir os resíduos!", 'error', null);
      return;
    }

    let data = getValues();
    let error = false;

    if (data.descricaoResiduo == "" || statusResiduo == "")
      error = true;

    if (error) {
      showMessage("Aviso", "Preencha todos os campos", 'error', null);
      return;
    }

    let json_submit = {
      residuo_Id: rowEdit != null ? rowEdit.residuo_Id : 0,
      classeResiduo_Id: classeResiduo_Id,
      descricao: data.descricaoResiduo,
      status: statusResiduo,
      usuarioCadastro_Id: session.usuario_Id,
      usuarioUltimaAlteracao_Id: session.usuario_Id
    }

    setLoading(true);
    if (json_submit.residuo_Id == 0) {
      api_POST('classeResiduo/PostResiduo', json_submit)
        .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { confirmacaoResiduoAdicionado(result.data); }))
        .catch(err => showMessage("Aviso", err.message, 'error', null))
        .finally(() => setLoading(false))
    }
    else {
      api_PUT('classeResiduo/PutResiduo', json_submit)
        .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { confirmacaoResiduoAdicionado(result.data); }))
        .catch(err => showMessage("Aviso", err.message, 'error', null))
        .finally(() => setLoading(false))
    }
  }

  const Voltar = (event, rowData) => {
    handleReturn();
  }

  const [h1_tab, set_h1_tab] = useState("ht1");

  const loadItem = () => {
    set_rowEdit(null);
    setValue("descricaoResiduo", "");
    setValue("statusResiduo", "", false);
    set_statusResiduo("");
    if (item != null) {
      set_classeResiduo_Id(item.classeResiduo_Id);
      setValue("descricao", item.descricao);
      set_status(item.status);
      setValue("status", item.status, true);
      set_list_table_residuos(item.residuos);
      set_categoria(item.categoria_Id);
    }
    else {
      set_classeResiduo_Id(0);
      set_status("");
      setValue("status", "", false);
      set_list_table_residuos([]);
    }
  }

  useEffect(() => {
    ValidaAcessoFuncionalidadeAcao("CadastroClassesResiduos.Editar", function (result) { set_permiteEditar(result) });
    loadOptionsCategoria();
    loadItem();
  }, []);

  const onSubmit = (data) => {
    let json_submit = {
      classeResiduo_Id: classeResiduo_Id,
      descricao: data.descricao,
      status: status,
      usuarioCadastro_Id: session.usuario_Id,
      usuarioUltimaAlteracao_Id: session.usuario_Id,
      categoria_Id: categoria
    }

    setLoading(true);
    if (json_submit.classeResiduo_Id == 0) {
      api_POST('classeresiduo', json_submit)
      .then(result => showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { set_classeResiduo_Id(result.data.classeResiduo_Id); }))
      .catch(err => showMessage("Aviso", err.message, 'error', null))
      .finally(() => setLoading(false))
    }
    else {
      api_PUT('classeresiduo', json_submit)
      .then(result =>  showMessage("Aviso", "Operação executada com sucesso!", 'success', null))
      .catch(err => showMessage("Aviso", err.message, 'error', null))
      .finally(() => setLoading(false))
    }
  }

  return (
    <>
      <div className="content">

        <Row>
          <Col md="12">
            <Button color="Primary" onClick={Voltar}><i className="fas fa-chevron-left"></i>  Voltar</Button>
            <Card className="card-user">
              <CardHeader>
                <Row><Col md="12" className="text-right"><label className="text-danger">* Campos Obrigatórios</label></Col></Row>
              </CardHeader>
              <CardBody>
                <Nav pills className="nav-pills-primary" style={{ cursor: "pointer" }}>
                  <NavItem>
                    <NavLink className={h1_tab === "ht1" ? "link-nav active" : "link-nav"} onClick={() => set_h1_tab("ht1")}><i class="fas fa-recycle"></i>  Classes </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink style={{ margin: "0px 10px" }} className={h1_tab === "ht2" ? "link-nav active" : "link-nav"} onClick={() => set_h1_tab("ht2")} ><i class="far fa-trash-alt"></i>  Resíduos </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={h1_tab} className="tab-space tab-principal">
                  <TabPane tabId="ht1">
                    <Row>
                      <Col md="12">
                        <div className="formPrincipal">
                          <Form onSubmit={handleSubmit(onSubmit)}>
                            <Row>
                              <Col md="12" lg="12">
                                <FormGroup>
                                  <b><label><span className="text-danger">*</span> Descrição da Classe</label></b>
                                  <Input type="text" name="descricao" maxLength={100} innerRef={register({ required: true })} />
                                  {errors.descricao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                              </Col>
                              <Col md="9" lg="9">
                                <FormGroup>
                                  <b><label><span className="text-danger">*</span> Categoria</label></b>
                                  <Select
                                    options={options_categoria}
                                    name="categoria"
                                    getOptionLabel={option => option.descricao}
                                    getOptionValue={option => option.categoria_Id}
                                    onChange={(e) => { handleCategoria(e.categoria_Id) }}
                                    value={categoria != null && options_categoria.find(obj => obj.categoria_Id === categoria)}
                                    placeholder="Selecione"
                                    ref={e => register(
                                      { name: "categoria" },
                                      { required: true })
                                    }
                                  />
                                  {errors.categoria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                              </Col>
                              <Col md="3" lg="3">
                                <FormGroup>
                                  <b><label><span className="text-danger">*</span> Status</label> </b>
                                  <Select
                                    options={options_status}
                                    name="status"
                                    onChange={(e) => { handleStatus(e.value) }}
                                    value={status != "" && options_status.find(obj => obj.value === status)}
                                    placeholder="Selecione"
                                    ref={e => register(
                                      { name: "status" },
                                      { required: true })
                                    }
                                  />
                                  {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                              </Col>
                              <Col md="12" className="text-center">
                                <Button color="success" disabled={!permiteEditar} className="btn-mobile" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                              </Col>
                            </Row>
                          </Form>
                        </div>
                      </Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="ht2">
                    <Row>
                      <Col md="12">
                        <div className="formPrincipal">
                          <Form>
                            <Row>
                              <Col md="8" lg="8">
                                <FormGroup>
                                  <b><label>Descrição do Resíduo</label></b>
                                  <Input type="text" name="descricaoResiduo" maxLength={100} innerRef={register({ required: false })} />
                                  {errors.descricaoResiduo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                              </Col>
                              <Col md="4" lg="4">
                                <FormGroup>
                                  <b><label>Status</label> </b>
                                  <Select
                                    options={options_statusResiduo}
                                    name="statusResiduo"
                                    onChange={(e) => { handleStatusResiduo(e.value) }}
                                    value={statusResiduo != "" && options_statusResiduo.find(obj => obj.value === statusResiduo)}
                                    placeholder="Selecione"
                                    ref={e => register(
                                      { name: "statusResiduo" },
                                      { required: false })
                                    }
                                  />
                                  {errors.statusResiduo && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                </FormGroup>
                              </Col>
                              <Col md="12" className="text-center">
                                <Button color="success" className="btn-mobile" type="button" onClick={() => handleAdicionarResiduo()}><i className="fas fa-plus"></i>  Adicionar</Button>
                              </Col>
                            </Row>
                          </Form>
                        </div>
                        <MaterialTable style={{ minHeight: "auto" }}
                          title=""

                          columns={[
                            { title: 'Resíduo', field: 'descricao' },
                            { title: 'Status', field: 'status' },
                          ]}
                          data={list_table_residuos}
                          isLoading={false}
                          options={{
                            filtering: false,
                            exportButton: true
                          }}
                          actions={[
                            {
                              icon: 'edit',
                              tooltip: 'Editar Registro',
                              onClick: (event, rowData) => handleEditarResiduo(rowData)
                            }
                          ]}
                          localization={{
                            header: {
                              actions: 'Ações'
                            },
                            body: {
                              emptyDataSourceMessage: 'Nenhum registro para exibir',
                              editRow: {
                                cancelTooltip: "Cancelar",
                                saveTooltip: "Salvar"
                              },
                              deleteTooltip: "Excluir",
                              editTooltip: "Editar"
                            },
                            toolbar: {
                              searchTooltip: 'Pesquisar',
                              searchPlaceholder: 'Pesquisar'
                            },
                            pagination: {
                              labelRowsSelect: 'linhas',
                              labelDisplayedRows: '{count} de {from}-{to}',
                              firstTooltip: 'Primeira página',
                              previousTooltip: 'Página anterior',
                              nextTooltip: 'Próxima página',
                              lastTooltip: 'Última página'
                            }
                          }}
                          Options={{
                            headerStyle: {
                              fontFamily: 'Montserrat, Helvetica Neue, Arial, sans-serif',
                              fontWeight: '700',
                              color: '#888'
                            }
                          }}
                        />
                      </Col>
                    </Row>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>

      </div>

    </>
  );
}

